import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface PhilosophyPrinciple {
  icon: string;
  title: string;
  description: string;
  color: string;
}

interface PhilosophySectionProps {
  principles: PhilosophyPrinciple[];
}

const PhilosophySection: React.FC<PhilosophySectionProps> = ({ principles }) => {
  return (
    <section className="py-20 pt-12 bg-background">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-5xl font-headline font-bold text-foreground mb-4">
            The "No Enemy" Philosophy
          </h2>
          <p className="text-lg text-muted-foreground max-w-3xl mx-auto">
            A radical approach to peace that begins with personal transformation and extends to global healing
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {principles.map((principle, index) => (
            <div
              key={index}
              className="bg-card p-8 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1 border border-border"
            >
              <div className={`w-16 h-16 rounded-full ${principle.color} flex items-center justify-center mb-6`}>
                <Icon name={principle.icon as any} size={32} className="text-white" />
              </div>
              <h3 className="text-xl font-headline font-bold text-foreground mb-4">
                {principle.title}
              </h3>
              <p className="text-muted-foreground font-body leading-relaxed">
                {principle.description}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-16 bg-gradient-to-r from-primary to-secondary p-12 rounded-2xl text-center">
          <h3 className="text-3xl font-headline font-bold text-white mb-6">
            Core Belief
          </h3>
          <p className="text-xl text-white/90 font-body leading-relaxed max-w-4xl mx-auto">
            Peace begins with the choice to have no enemy. When we release hostility from our hearts, we create space for healing, understanding, and genuine transformation. This is not passive acceptance—it's the courageous act of choosing compassion over conflict.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PhilosophySection;